export const initialState = {
  exampleList: [],
  example2List: []
};

const appReducer = (state = initialState, action) => {
  switch (action.type) {
    case "EXAMPLE": {
      return { ...state, exampleList: action.payload };
    }
    case "EXAMPLE2": {
      return { ...state, example2List: action.payload };
    }
    default: {
      return state;
    }
  }
};

export default appReducer;
